import { render } from "./NovusServers.vue?vue&type=template&id=3da2427c"
import script from "./NovusServers.vue?vue&type=script&lang=js"
export * from "./NovusServers.vue?vue&type=script&lang=js"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__